import { render, staticRenderFns } from "./ModernAntimatterDimensionRow.vue?vue&type=template&id=59f5698c&scoped=true"
import script from "./ModernAntimatterDimensionRow.vue?vue&type=script&lang=js"
export * from "./ModernAntimatterDimensionRow.vue?vue&type=script&lang=js"
import style0 from "./ModernAntimatterDimensionRow.vue?vue&type=style&index=0&id=59f5698c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f5698c",
  null
  
)

export default component.exports